import store from '@/store'

export function hasPermission(permission) {
  const permissions = store.state.user.permissions
  return permissions && permissions.includes(permission)
}

export default {
  inserted(el, binding) {
    // inserted 只执行一次，但此时权限可能还没加载完
    // 先隐藏，等 update 再评估
    el.style.display = hasPermission(binding.value) ? '' : 'none'
  },
  update(el, binding) {
    // 每次组件更新(包括 store 变化)都会执行
    el.style.display = hasPermission(binding.value) ? '' : 'none'
  }
}
